module.exports = __webpack_public_path__ + "static/media/bike2d.f7fe5d85.jpg";